
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';

import {VueAssistant} from './framework';
//引入项目文件
import RouterConfig from './configs/RouterConfig'   //路由配置文件
import GlobalFunctions from './configs/GlobalFunctions' //公共方法
import NetworkConfig from './configs/NetworkConfig' //网络配置

import StoreConfig from './configs/StoreConfig'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(VueRouter)
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(ViewUI);

//引入国际化插件
// var VueI18n=require('vue-i18n');
// import VueI18n from 'vue-i18n';
// import VueValidator from 'vue-validator'
// Vue.use(VueValidator);
// Vue.use(VueI18n);

VueAssistant.instance.configRouter(VueRouter,RouterConfig);
VueAssistant.instance.configNetwork(NetworkConfig);
VueAssistant.instance.configGlobalFunctions(GlobalFunctions);
// VueAssistant.instance.configStore(Vuex,StoreConfig)
// console.log('router',VueAssistant.instance.routerConfig);
VueAssistant.instance.config(Vue);

var router = VueAssistant.instance.router;
var store = new Vuex.Store(StoreConfig);// VueAssistant.instance.store;
console.log('====',store)
Vue.config.productionTip = false

import App from './App.vue';

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
